/**
 * D-90 (OD-79): only someone the server marks `payVisible` (owner/admin) may
 * send a shift's pay rate. Everyone else's add, bulk-add and edit requests
 * must leave the key out altogether — the server answers 403 to the key, and
 * a hidden, empty box sent as `null` would otherwise wipe the owner's rate.
 */
export function shiftPayField(
  payVisible: boolean,
  rate: number | null,
): { payrollHourlyRateEur?: number | null } {
  return payVisible ? { payrollHourlyRateEur: rate } : {};
}
